export default __webpack_public_path__ + "48960f9044de1fa936444ced3074365c.png";